import { Track } from "@/src/lib/tracking";
/**
 * 获取热门新闻的工具函数
 * 调用外部API: https://9c7bcdf43b7f.ngrok-free.app/api/hot-news
 */

// 定义API响应的数据类型
import { config } from "@config/config";
import type { ThemeItem } from "@features/api/openData";

const mockNewsData = {
  id: 1388,
  documentId: "he1jpp2hb69pxphos5u1lq2x",
  Title: "Japan's Inflation Dips to 1.3%, Complicating BOJ Rate Hike Path",
  HeadImg:
    "https://osp-crawlers-dev.oss-ap-southeast-1.aliyuncs.com/news/images/japans-inflation-dips-to-13-complicating-boj-rate-hike-path-20260324.png",
  Content:
    'Japan’s core inflation fell below the central bank’s 2% target for the first time in nearly four years, dropping to 1.6% in February and complicating the Bank of Japan\'s timeline for further interest rate hikes.\n\n"Inflationary pressures are more entrenched than the weak headline result for February would suggest," said Abhijit Surya, senior APAC economist at Capital Economics, noting that government subsidies are masking underlying pressures.\n\nThe headline consumer price index slowed to 1.3% from 1.5% in January, while the yen held steady near 158.59 per dollar. In contrast, the Nikkei 225 index rallied over 2% as traders pushed back expectations for another rate increase.\n\nWith the Bank of Japan having just raised its policy rate to 0.75% in a historic move last month, this sharp inflation dip creates a dilemma. The BOJ must now decide whether to prioritize the cooling data or react to rising energy prices from Middle East turmoil, with some analysts now pointing to a potential hike in June or July.\n\n### Subsidies Mask Underlying Pressures\n\nThe February inflation data, released Tuesday by Japan\'s Statistics Bureau, showed the slowdown was heavily influenced by government intervention. The core inflation reading of 1.6%, which strips out volatile fresh food prices, missed analyst forecasts for a 1.7% print. A deeper measure of trend inflation, the "core-core" index that also excludes energy, eased slightly to 2.5% from 2.6% in January, remaining well above the central bank\'s target.\n\nThis suggests that while government policies are successfully lowering headline costs for consumers, underlying demand-driven inflation has not cooled as significantly. Utilities costs fell 5.5% from a year earlier, with electricity and gas prices declining 8% and 5.1% respectively, a direct result of renewed government subsidies. The government also introduced a cap on gasoline prices this month, which analysts estimate could depress the core CPI by as much as 0.5 percentage points.\n\nBank of Japan Governor Kazuo Ueda has acknowledged this distortion, stating last week the central bank would develop a new price indicator to exclude the effects of these one-time policy factors. This move is seen by some as a way to build a case for further rate hikes once the statistical noise is stripped out.\n\n### Geopolitical Risks and Economic Weakness\n\nThe Bank of Japan’s policy calculus is further complicated by external shocks and a weak domestic economy. The conflict in the Middle East poses a significant upside risk to inflation for an energy importer like Japan. "The [Middle East] conflict is an unwelcome surprise," said Stefan Angrick, an economist at Moody\'s Analytics, who believes a prolonged war could deal a heavy blow to the economy and now expects the BOJ to raise rates in June or July.\n\nAt its last meeting, the central bank held its policy rate at 0.75% in an 8-to-1 vote, a decision made after its first rate hike in decades. Governor Ueda stated he "needs more time" to assess the impact of the war on Japan\'s economy and prices.\n\nThis cautious stance is amplified by Japan\'s sluggish growth. The economy expanded by just 0.1% year-on-year in the fourth quarter of last year, narrowly avoiding a technical recession. Raising rates further to combat potential supply-driven inflation could risk tipping the fragile economy over the edge. For now, markets are pricing in a more patient Bank of Japan, a sentiment that has kept the yen weak against the dollar, with authorities verbally intervening to keep the USD/JPY pair from breaching the 160 level.\n\nThis article is for informational purposes only and does not constitute investment advice.',
  EnTitle: "japans-inflation-dips-to-13-complicating-boj-rate-hike-path",
  createdAt: "2026-03-24T07:08:48.890Z",
  updatedAt: "2026-03-24T11:51:41.333Z",
  publishedAt: "2026-03-24T11:51:41.403Z",
  locale: "en",
  Summary:
    "**Key Takeaways**\n\n*   Japan’s core inflation fell to 1.6% in February, dipping below the Bank of Japan's 2% target for the first time since March 2022 and complicating the path for further rate hikes.\n*   The slowdown was driven largely by government energy subsidies, which analysts believe are masking more persistent underlying price pressures in the economy.\n*   The Bank of Japan is now in a difficult position, balancing cooling domestic data against rising global energy prices from geopolitical tensions, with its next move now keenly watched.",
  AgentId: "",
  Level: "",
  Description:
    "Japan's February 2026 headline inflation slowed for a fourth straight month to 1.3%, falling below the Bank of Japan's 2% target and complicating its path for future rate hikes.",
  Report: null,
  Author: "Edgen Stock",
  Channel: "Economy",
  Sector: "Central Banks",
  Themes: [
    {
      id: 8996,
      Name: "Central Banks",
      ThemeId: "4cff012631064f33ad38d5791d0af4ff",
    },
  ],
  Seo: {
    id: 1936,
    metaTitle:
      "Japan's Inflation Dips to 1.3%, Complicating BOJ Rate Hike Path",
    metaDescription:
      "Japan's February 2026 headline inflation slowed for a fourth straight month to 1.3%, falling below the Bank of Japan's 2% target and complicating its path for future rate hikes.",
    metaImg:
      "https://osp-crawlers-dev.oss-ap-southeast-1.aliyuncs.com/news/images/japans-inflation-dips-to-13-complicating-boj-rate-hike-path-20260324.png",
    metaAlt:
      "A shopper walks through the Tsukiji shopping area in Tokyo, where Japan's national headline inflation slowed to 1.3% in February.",
  },
  Tokens: [],
  Analyst: {
    id: 91,
    documentId: "zv3tog6an271hr1roszch6e4",
    name: "Alex Nguyen",
    slug: "alex-nguyen",
    title: "AI & Software Reporter",
    bio: "Enterprise AI adoption, SaaS earnings, and cybersecurity. Covered the startup beat at The Information before joining Edgen. Thinks most AI revenue projections are too optimistic.new",
    avatar: "https://static.edwealth.ai/authors/alex-nguyen.png",
    createdAt: "2026-03-24T08:42:16.089Z",
    updatedAt: "2026-03-24T11:41:26.046Z",
    publishedAt: "2026-03-24T11:41:26.059Z",
  },
  References: [
    {
      id: 4112,
      Name: "Japan core inflation in February misses estimates, headline CPI eases for a fourth straight month - CNBC",
      Url: "https://www.cnbc.com/2026/03/24/japan-cpi-inflation-february-.html",
    },
    {
      id: 4113,
      Name: "The Week Ahead: Inflation watch, Flash PMIs, Carnival earnings",
      Url: "https://www.cmcmarkets.com/en-nz/market-news/the-week-ahead-inflation-watch-flash-pmis-carnival-earnings",
    },
    {
      id: 4114,
      Name: "Bank of Japan keeps policy rate unchanged as Iran war complicates next step decision",
      Url: "https://mainichi.jp/english/articles/20260319/p2g/00m/0bu/023000c",
    },
    {
      id: 4115,
      Name: "Bank of Japan holds rates and offers no signal about its next move",
      Url: "https://think.ing.com/snaps/bank-of-japan-holds-rates-and-offers-no-signal-about-next-move/",
    },
  ],
};

/**
 * 将Markdown文本转换为纯文本
 * @param markdown Markdown格式的文本
 * @returns 转换后的纯文本
 */
function markdownToPlainText(markdown: string): string {
  if (!markdown) {
    return "";
  }

  // 移除标题标记 (# ## ### 等)
  let plainText = markdown.replace(/#{1,6}\s?/g, "");

  // 移除粗体和斜体标记 (** * __ _)
  plainText = plainText.replace(/[\*_]{1,2}([^\*_]+)[\*_]{1,2}/g, "$1");

  // 移除链接 [text](url) 只保留文本部分
  plainText = plainText.replace(/\[([^\]]+)\]\([^)]+\)/g, "$1");

  // 移除图片标记 ![alt](url)
  plainText = plainText.replace(/!\[[^\]]*\]\([^)]+\)/g, "");

  // 移除代码块
  plainText = plainText.replace(/```[\s\S]*?```/g, "");

  // 移除行内代码
  plainText = plainText.replace(/`([^`]+)`/g, "$1");

  // 移除HTML标签
  plainText = plainText.replace(/<[^>]*>/g, "");

  // 移除多余的空行，将连续多个空行替换为一个换行
  plainText = plainText.replace(/\n{3,}/g, "\n\n");

  // 移除前后空白
  plainText = plainText.trim();

  return plainText;
}

// API认证Token
// export const API_TOKEN =
// "f707fffc4755f9bb85ff8362005bb1bb0b01ddd4fe70149c2c1e5fe4b8100ecac0d4c782a0ad6d88fe66526e2202e6f5bf86feedc7af756993254cd68c0edbc4932d5ce5faf31ec99d46c759a7419fddd9403555907c0eab4c90f647d3d1cc070fb278536a98ec8300f503f7618cf51f87608ae07678cb07276ffe12188cc8f8";

interface NewsToken {
  id: number;
  Name: string;
  SymbolId: string;
}

interface NewsReference {
  id: number;
  Name: string;
  Url: string;
}

interface NewsSeo {
  id: number;
  metaTitle: string;
  metaDescription: string;
  metaImg: string;
  metaAlt: string;
}
export interface NewsTheme {
  Name: string;
  ThemeId?: string;
  id?: number;
  /** SSR 由 getNewsDetailById 注入，含 parentTheme（与 themes.json / ranking 一致） */
  themeItem?: ThemeItem & {
    parent_theme_id?: string;
    sort?: number | string | null;
    parentTheme?: ThemeItem | null;
  };
}

/** 新闻关联作者 / 分析师（Strapi 等接口 populate） */
export interface NewsAnalyst {
  id: number;
  documentId: string;
  name: string;
  slug: string;
  title?: string;
  bio?: string;
  avatar?: string;
  createdAt?: string;
  updatedAt?: string;
  publishedAt?: string;
}

export interface NewsData {
  id: number;
  documentId: string;
  Title: string;
  createdAt: string;
  updatedAt: string;
  publishedAt: string;
  locale: string;
  Content: string;
  desc?: string; // 添加可选的desc字段，用于存储Content的纯文本版本
  Author: string;
  Channel: string;
  HeadImg: string;
  Seo: NewsSeo;
  Tokens: NewsToken[];
  References: NewsReference[];
  EnTitle: string;
  Themes: NewsTheme[];
  Summary: string;
  Analyst?: NewsAnalyst | null;
}

function getApiLocale(locale: string) {
  switch (locale) {
    case "zh-tw":
      return "zh-Hant";
    default:
      return locale;
  }
}

// 单条新闻详情响应类型 (基于提供的API响应数据)
interface NewsDetailApiResponse {
  data: NewsData[] | null;
}

/**
 * 获取单条新闻详情
 * @param documentId 新闻文档ID
 * @param locale 语言locale，默认为'en'
 * @returns Promise<NewsDetailApiResponse | null>
 */
export async function fetchNewsDetailByTitle(
  title: string,
  locale: string = "en",
  useMock: boolean = false,
): Promise<NewsData | null> {
  if (useMock) {
    return {
      ...mockNewsData,
      desc: markdownToPlainText(mockNewsData.Content),
    };
  }

  try {
    // 构建API URL - 使用documentId作为路径参数
    const apiUrl = config.api.baseUrl.strApi + `/news`;

    // 构建查询参数
    const searchParams = new URLSearchParams({
      locale: getApiLocale(locale),
      "populate[Themes]": "*",
      "populate[Seo]": "*",
      "populate[Tokens]": "*",
      "populate[References]": "*",
      "populate[Analyst]": "true",
      "filters[EnTitle][$eq]": title,
    });

    // 发起请求
    const response = await fetch(`${apiUrl}?${searchParams}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        Authorization: `Bearer ${config.api.token.strApi}`,
      },
      // 缓存策略 - 新闻详情可以缓存更长时间
      // cache: "force-cache",
    });

    // 检查响应状态
    if (!response.ok) {
      Track.log(
        "error",
        "fetchHotNews",
        `❌ 获取新闻详情失败: ${response.status} ${response.statusText}`,
      );
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    // 解析JSON响应
    const data: NewsDetailApiResponse = await response.json();

    // log.debug(`[fetchHotNews]✅ 成功获取新闻详情:Json:${JSON.stringify(data)}`);

    return data?.data?.[0] || null;
  } catch (error) {
    Track.log(
      "error",
      "fetchHotNews",
      `❌ 获取新闻详情失败 (title: ${title}):`,
      { cause: String(error) },
    );

    // 可以根据错误类型进行不同处理
    if (error instanceof TypeError) {
      Track.log("error", "fetchHotNews", "网络错误或CORS问题");
    } else if (error instanceof SyntaxError) {
      Track.log("error", "fetchHotNews", "JSON解析错误");
    }

    return null;
  }
}
